/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../generators/lua.js';
$['__chunk_lua'] = exports;
